import { getJsonItem } from '../Utilities/JsonFunctions.js';
import { ajaxGetAnon } from './AjaxHelper.js';
declare var $;
declare var Cookies;

//import update from 'immutability-helper';

export function getSalaryPeriods(languageId, callback) {
    ajaxGetAnon("/api/namezzz/salaryperiods?seqlang=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getLanguages(languageId, limited, callback) {
    ajaxGetAnon("/api/namezzz/languages?seqlang=" + languageId + "&limited=" + limited, (data, ok) => {
        if (!ok) {
            callback(null);
            return;
        }
        
        var item = getJsonItem(data, "key", 9);

        if (!limited) {
            var index = data.indexOf(item);
            data[index]["disabled"] = true;
        }

        callback(data);
    });
}

export function getCountries(languageId, callback) {
    ajaxGetAnon("/api/namezzz/countries?seqlang=" + languageId, (data, ok) => {
        if (!ok) {
            callback(null);
            return;
        }
        
        var item = getJsonItem(data, "key", 185);
        var index = data.indexOf(item);

        data[index]["disabled"] = true;

        callback(data);
    });
}

export function getMedia(languageId, callback) {
    ajaxGetAnon("/api/namezzz/media?seqlang=" + languageId, (data, ok) => {
        callback(ok ? data: null);
    })
}

export function getJobOrgPub(languageId, jobId, callback) {
    ajaxGetAnon("/api/namezzz/joborgpub?languageId=" + languageId + "&jobId=" + jobId, (data, ok) => {
        callback(ok ? data: null);
    })
}

export function getResults(languageId, callback) {
    ajaxGetAnon("/api/namezzz/results?seqlang=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getEducationDomain(languageId, countryId, callback) {
    ajaxGetAnon("/api/namezzz/education/domain?seqlang=" + languageId + "&seqcountry=" + countryId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getEducationNiveau(languageId, eduDomainId, callback) {
    ajaxGetAnon("/api/namezzz/education/niveau?seqlang=" + languageId + "&seqedudomain=" + eduDomainId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getAllRegions(languageId, callback) {
    ajaxGetAnon("/api/namezzz/regions?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getRegions(languageId, regionId, callback) {
    ajaxGetAnon("/api/namezzz/regions/" + regionId + "?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getFileExtensions(callback) {
    ajaxGetAnon("/api/namezzz/files/extensions", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getFileMimeTypes(callback) {
    ajaxGetAnon("/api/namezzz/files/mimetypes", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function getFileMaxSizeMb(callback) {
    ajaxGetAnon("/api/namezzz/files/maxsizemb", (data, ok) => {
        callback(ok ? data : null);
    });
}


// WEBPACK FOOTER //
// ./src/Api/Namezzz.js